import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addPlanzoneVirtualResource(
    request: Boundaries["addPlanzoneVirtualResource"]["request"],
  ): void;
}

function useAddPlanzoneVirtualResource(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAddPlanzoneVirtualResourceRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAddPlanzoneVirtualResourceRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAddPlanzoneVirtualResourceRequestFailure,
    ),
    addPlanzoneVirtualResource: core.addPlanzoneVirtualResource,
  };
}

export { useAddPlanzoneVirtualResource };
